<template>
  <div>
    <div class="flex flex-right align-items-center mb8">
      <div class="flex align-items-center" style="margin-right: 8px">
        <div>名称：</div>
        <a-input
          style="width: 150px"
          type="text"
          @change="search"
          v-model="queryCriteria.realname"
          allowClear
          placeholder="请输入名称"
        />
      </div>
      <div
        class="flex align-items-center"
        v-if="$store.state.role != 'school-role'"
        style="margin-right: 8px"
      >
        <div>所属部门：</div>
        <a-select
          style="width: 180px"
          v-model="queryCriteria.orgCode"
          show-search
          allowClear
          option-filter-prop="children"
          :filter-option="filterOption"
          @change="search"
        >
          <a-select-option
            :value="item.orgCode"
            v-for="(item, index) in sslist"
            :key="index"
            >{{ item.departName }}</a-select-option
          >
        </a-select>
      </div>
      <a-button style="margin-right: 10px" type="primary" @click="search"
        >查询</a-button
      >
      <a-upload
        :before-upload="beforeUpload"
        accept=".xls,.xlsx"
        :showUploadList="false"
      >
        <a-button style="margin-right: 10px" type="primary">导入</a-button>
      </a-upload>
      <a-button style="margin-right: 10px" type="primary" @click="exportFile"
        >导出</a-button
      >
      <a-button class="add-btn" @click="addPage(type)">
        新增{{ type === "" ? "" : type }}
      </a-button>
    </div>
    <div>
      <a-table
        style="text-align: center"
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :pagination="pagination"
        @change="handleTableChange"
        :bordered="true"
        rowKey="id"
        :locale="{ emptyText: '暂无数据' }"
        :scroll="tableScroll"
      >
        <span slot="username" slot-scope="text">
          <div class="username" :title="text">{{ text }}</div>
        </span>
        <span slot="realname" slot-scope="text">
          <div class="realname" :title="text">{{ text }}</div>
        </span>
        <span
          class="flex flex-around"
          slot="action"
          slot-scope="record"
          style="margin: 0 10px"
        >
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            @click="editInfo(record)"
          >
            <img class="img-box" src="../../assets/images/img42.png" alt="" />
            <span>编辑</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            @click="deleteInfo(record)"
          >
            <img class="img-box" src="../../assets/images/img43.png" alt="" />
            <span>移除</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            @click="resetPasswords(record)"
          >
            <img
              class="img-box-reset"
              src="../../assets/images/img52.png"
              alt=""
            />
            <span>初始密码</span>
          </div>
        </span>
      </a-table>
    </div>
  </div>
</template>

<script>
import { userLxExport, userLxImport, getAction } from "@/api/index"; //
const columns = [
  {
    title: "工作室名称",
    dataIndex: "name",
    id: "name",
    align: "center",
  },
  {
    title: "项目负责人",
    dataIndex: "principals",
    id: "principals",
    align: "center",
  },
  {
    title: "联系电话",
    dataIndex: "phone",
    id: "phone",
    align: "center",
  },
  {
    title: "操作",
    id: "action",
    align: "center",
    width: 354,
    scopedSlots: { customRender: "action" },
  },
];

const data = [];
export default {
  name: "",
  components: {},
  props: {
    columns: {
      type: Array,
      default: () => columns,
    },
    loading: Boolean,
    data: {
      type: Array,
      default: () => data,
    },
    type: {
      type: String,
      default: "",
    },
    pagination: {
      type: Object,
    },
  },
  data() {
    return {
      queryCriteria: {
        realname: "",
        orgCode: "",
      },
      sslist: [],
    };
  },
  computed: {
    tableScroll() {
      // 根据 role 来动态设置 scroll
      return this.$store.state.role !== "school-role" ? { x: 1280 } : {}; // 如果是 'school-role'，不设置 x
    },
  },
  watch: {},
  created() {},
  mounted() {
    this.getpp();
  },
  methods: {
    getpp() {
      getAction("/sys/sysDepart/departList", {}).then((res) => {
        if (res.code == 200) {
          // console.log(res);
          this.sslist = res.result;
        }
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    search() {
      this.$emit("search", this.queryCriteria);
    },
    addPage(type) {
      this.$emit("showAddPop", type);
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.$emit("getLxApplyApplylist", this.pagination);
    },
    deleteInfo(row) {
      this.$emit("deleteApply", row.id);
    },
    editInfo(row) {
      this.$emit("editInfo", row);
    },
    resetPasswords(row) {
      this.$emit("resetPasswords", row);
    },
    exportFile() {
      let params = {
        roleCode:
          this.type === "学校"
            ? "school-role"
            : this.type === "教师"
            ? "teacher-role"
            : "audit-role",
      };
      userLxExport(params).then((res) => {
        let url = window.URL.createObjectURL(
          new Blob([res], { type: "application/vnd.ms-excel" })
        );
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute(
          "download",
          `铸魂育人遴选-${this.type}账户` + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); //下载完成移除元素
        window.URL.revokeObjectURL(url); //释放掉blob对象
      });
    },

    beforeUpload(file) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append(
        "roleCode",
        this.type === "学校"
          ? "school-role"
          : this.type === "教师"
          ? "teacher-role"
          : "audit-role"
      );
      userLxImport(formData).then((res) => {
        if (res.code === 200) {
          this.$emit("getLxApplyApplylist", this.pagination);
        } else {
          this.$message.warning(res.message);
        }
      });
      // this.fileList = [...this.fileList, file];
      // return false;
    },
  },
};
</script>

<style scoped lang="scss">
.header-time-box {
  width: 363px;
  height: 32px;
  line-height: 30px;
  text-align: center;
  background: rgba(156, 3, 5, 0.1);
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #2155b5;
  border-radius: 10px;
}
.add-btn {
  text-align: center;
  background: #2155b5;
  border: 1px solid #2155b5;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}
.mb8 {
  margin-bottom: 8px;
}
.img-box {
  width: 18px;
  height: 18px;
  margin-right: 9px;
}
.img-box-reset {
  width: 22px;
  height: 22px;
  margin-right: 9px;
}
.table-box {
  text-align: center;
}
.username {
  // width: 100px;
  margin: 0 auto;
}
.realname {
  // width: 150px;
  margin: 0 auto;
}
</style>
